import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Container } from '@resurs/midas-react'
import {
  getUserNews,
  markSeveralAsRead,
} from '../../store/actions/news-actions'
import NewsList from './List/NewsList'

const NewsContainer = ({ userNews, markAsRead, getNews }) => {
  useEffect(() => getNews(), [])
  useEffect(() => userNews && markAsRead(userNews.articles), [userNews])

  if (!userNews) {
    return null
  }
  return (
    <Container grid960>
      {userNews.articles && <NewsList articles={userNews.articles} />}
    </Container>
  )
}

NewsContainer.propTypes = {
  userNews: PropTypes.object.isRequired,
  getNews: PropTypes.func.isRequired,
  markAsRead: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  userNews: state.news.userNews,
})

const mapDispatchToProps = dispatch => ({
  getNews: () => {
    dispatch(getUserNews())
  },
  markAsRead: articleList => {
    dispatch(markSeveralAsRead(articleList))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(NewsContainer)
